import React from 'react';

export interface PercentageCellProps {
  promotion: { discount?: number };
  game?: any;
  editable?: boolean;
}

function PercentageCell({ promotion, game, editable }: PercentageCellProps) {
  const discount = promotion?.discount ?? 0;
  return editable ? (
    <div className="grid-pct">
      <input
        type="text"
        className="form-control me-2"
        value={(discount * 100).toFixed()}
        readOnly
      />{' '}
      %
    </div>
  ) : (
    <div className="grid-pct-readonly">
      {(discount * 100).toFixed()}%
    </div>
  );
}

export default PercentageCell;
